import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { UserList } from "@/components/ui/UserList";
import { Loading } from "@/layouts/components";
import { useGetUsersQuery } from "@/store/api";
export var AllUserList = function (props) {
    var userListGetState = useGetUsersQuery({ text: props.searchQuery });
    return (_jsxs(_Fragment, { children: [_jsx(Loading, { isActive: !userListGetState.isSuccess, loadingKey: "userList" }), userListGetState.isSuccess && (_jsx(UserList, { onDetailsClick: props.onDetailsClick, data: userListGetState.data }))] }));
};
